import BaseTable from "./base-table";

function RequiredTable() {
    return (
        <BaseTable>
            <tbody>
                <tr>
                    <td className="border border-gray-300 p-2">FormToken</td>
                    <td className="border border-gray-300 p-2">skorstensgaard.dk</td>
                    <td className="border border-gray-300 p-2">Forebygger Cross-Site Request Forgery (CSRF)</td>
                    <td className="border border-gray-300 p-2">session</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_skg_cookieconsent</td>
                    <td className="border border-gray-300 p-2">skorstensgaard.dk</td>
                    <td className="border border-gray-300 p-2">Gemmer dit cookie samtykke for dette website</td>
                    <td className="border border-gray-300 p-2">1 år</td>
                    <td className="border border-gray-300 p-2">cookie</td>
                </tr>
            </tbody>
        </BaseTable>
    )
}

export default RequiredTable;